<!--  -->
<template>
  <div class="mainBackground">
    <header-bar :type="type"></header-bar>
    <div class="img-cont">
      <img class="bg-img" id="red" src="~@/assets/login/red.svg" />
      <img class="bg-img" id="green" src="~@/assets/login/green.svg" />
      <img class="bg-img" id="blue" src="~@/assets/login/blue.svg" />
    </div>
    <div class="login-cont">
      <login-methods v-if="bindShow"></login-methods>
      <!-- <router-view></router-view> -->
      <p class="footer">
        ©2021 hs.net 版权所有 ICP备案号：浙ICP备09092082号-30 ICP
        经营许可证：浙B2-20170536
      </p>
    </div>
    <h-msg-box
      v-model="showJoinModal"
      closable
      :mask-closable="false"
      @on-close="closeJoinModal"
    >
      <p slot="header">
        <h-icon
          name="android-alert"
          style="color:#F5A623;font-size:20px;vertical-align: bottom;"
        ></h-icon>
        <span>关于平台用户体系升级的通知</span>
      </p>
      <p>尊敬的GMU平台用户：</p>
      <p>
        为了给用户提供更好的服务，GMU平台进行了用户体系升级。如您通过账号密码登录失败，可使用<span
          style="color: #396AFF;cursor:pointer"
          @click="resetPwd(2)"
          >手机验证码</span
        >登录；或在登录页面点击<span
          style="color: #396AFF;cursor:pointer"
          @click="resetPwd(1)"
          >忘记密码</span
        >，修改密码成功后重新登录。
      </p>
      <p>感谢您的理解与配合！</p>

      <br />
      <p>客服支持/咨询:0571-26691719</p>
      <p slot="footer">
        <h-button type="primary" @click="joinModalOk">确定</h-button>
      </p>
    </h-msg-box>
  </div>
</template>

<script>
import HeaderBar from "@/views/frontViews/components/headerBar";
import LoginMethods from "@/views/frontViews/components/loginMethods";
import { isLoginJson, CASLoginAPI } from "@/api/login.js";
import { getUrlParam } from "@/utils";
import axios from "axios";
import { guideForgetPasswdApi } from "@/api/indexApi";

export default {
  name: "login",
  data() {
    return {
      type: "login",
      formData: {},
      formRules: {},
      isSave: false,
      flag: true,
      show: true,
      seconds: 60,
      isLoginSeconds: 60,
      bindShow: this.$route.name == "微信绑定手机" ? false : true,
      timer: null,
      showJoinModal: false
    };
  },
  components: {
    HeaderBar,
    LoginMethods
  },
  methods: {
    resetPwd(type) {
      const urlSearch = location.search;
      const urlSplit = urlSearch.split("service=");
      const url = urlSplit[urlSplit.length - 1];
      localStorage.setItem("backUrl", decodeURIComponent(url));
      if (type === 1) {
        return (location.href = "/openplat-front/forgetPassword");
      }
      if (type === 2) {
        return (location.href = "/openplat-front/login?loginType=message");
      }
    },
    guideForgetPasswd() {
      guideForgetPasswdApi({
        browser_fingerprint: localStorage.getItem("browserId")
      }).then(res => {
        this.showJoinModal = res;
      });
    },
    closeJoinModal() {
      this.showJoinModal = false;
    },
    joinModalOk() {
      this.closeJoinModal();
    },
    start(dom, startX, startY, speed, towards) {
      var main = document.getElementById(dom);
      var sy = startY;
      var speedy = 1;
      var sx = startX;
      var speedx = 1;

      var imgh = 200;
      var imgw = 200;

      var winh = document.documentElement.clientHeight;
      var winw = document.documentElement.clientWidth;
      setInterval(function() {
        if (towards) {
          sy += speedy;
          sx += speedx;
        } else {
          sy -= speedy;
          sx -= speedx;
        }

        //y轴运动
        if (sy <= 0) {
          speedy = -speedy;
        }
        if (sy >= winh - imgh) {
          speedy = -speedy;
          sy = winh - imgh;
        }
        //x轴运动
        if (sx <= 0) {
          speedx = -speedx;
        }
        if (sx >= winw - imgw) {
          speedx = -speedx;
          sx = winw - imgw;
        }
        main.style.top = sy + "px";
        main.style.left = sx + "px";
      }, speed);
    },
    //revise by wyy:此处产生老网站登录，二级域名一直刷新得问题，改为用js判断是否登录
    //revise by wyy: 修改成调用用户中心
    getIsLoginJson() {
      let _this = this;
      CASLoginAPI().then(res => {
        if (res.data.indexOf("true") != -1) {
          _this.loginCallBack();
        }
      });
    },
    loginCallBack() {
      let url = getUrlParam(window.location.href, "service");
      if (url != "") {
        if (
          decodeURIComponent(url).indexOf(window.LOCAL_CONFIG.userCenter) == -1
        ) {
          // 只有当前url 有service参数时才跳转
          window.location.href =
            window.LOCAL_CONFIG.userCenter + "/login?service=" + url;
        } else {
          //if CAS has Login, exc callback, else do nothing
          CASLoginAPI().then(res => {
            if (res.data.indexOf("true") != -1) {
              window.location.href = decodeURIComponent(url);
            }
          });
        }
      }
    }
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.getIsLoginJson();
    const urlSearch = decodeURIComponent(location.search);
    if (
      urlSearch.includes("lightyy.com") ||
      urlSearch.includes("qinglight.com")
    ) {
      this.guideForgetPasswd();
    }
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.start("red", 250, 700, 12);
    this.start("green", 80, 350, 13, "right");
    this.start("blue", 1300, 120, 14, "right");
  }
};
</script>
<style lang="scss" scoped>
.mainBackground {
  background: #f3f7fe;
  height: 100%;
  position: relative;

  .img-cont {
    min-height: calc(100vh - 82px);
    position: relative;
    overflow: hidden;
    z-index: 0;
    background: transparent;
    height: 100vh;
    width: 100%;
    // top: 0;
    // left: 0;
    .bg-img {
      position: absolute;
      width: 400px;
      height: 400px;
    }
  }
  // position: relative;
  .login-cont {
    width: 1200px;
    // height: 579px;
    /*background: url(/open/images/register/registBg.png) center center no-repeat;*/
    /*background-size: 100% 100%;*/
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .footer {
      margin-top: 40px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #999999;
      text-align: center;
      line-height: 12px;
    }
  }
}
</style>

//
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/gtn/views/login.vue